// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"537":"a03f2823","2808":"f34e0124","3192":"086e7dc9","5668":"910395c3","6513":"9fa04bc0","7512":"59052616","7569":"ad64dcc2","7849":"086e7dc9","8245":"910395c3","8709":"c438b8d0"}[chunkId] + ".chunk.css";
};